import { inject, Injectable } from "@angular/core";
import { Loader } from "@googlemaps/js-api-loader";
import { ToastrService } from "ngx-toastr";
import { RotaMaps } from "../models/maps/rota.model";
import { ConvivaErrorHandlingService } from "./convivaErrorHandlingService";


@Injectable({ providedIn: 'root' })
export class MapsService {
  public loader: Loader;
  toastr = inject(ToastrService);
  convivaErrors = inject(ConvivaErrorHandlingService);

  public requestRoute: google.maps.DirectionsRequest = <google.maps.DirectionsRequest>{};
  public resultRoute: google.maps.DirectionsResult = <google.maps.DirectionsResult>{};

  constructor() {
    this.loader = new Loader({
      apiKey: "AIzaSyBW3-1Uqc00l6-rwd-KZkdIZWmS5MnGMsk",
      version: 'weekly',
      libraries: ['places', 'drawing', 'visualization', 'geometry'],
    });
  }


  async calculateDistance(
    latitudeOrigem: number,
    longitudeOrigem: number,
    latitudeDestino: number,
    longitudeDestino: number,
    showWarningToast: boolean = true
  ): Promise<RotaMaps | undefined> {
      // console.log(`${latitudeOrigem},${longitudeOrigem}`)
      // console.log(`${latitudeDestino},${longitudeDestino}`)

    await this.loader.load();
    const importMapsRoutes = await this.loader.importLibrary('routes');
    const serviceRoute = new importMapsRoutes.DirectionsService();
    let gerouRota = false;
    this.requestRoute.origin = this.getLatLong(latitudeOrigem, longitudeOrigem)
    this.requestRoute.destination = this.getLatLong(latitudeDestino, longitudeDestino);
    this.requestRoute.travelMode = google.maps.TravelMode.WALKING;

    await serviceRoute.route(this.requestRoute, (result, status) => {
      if (status == google.maps.DirectionsStatus.ZERO_RESULTS) {
        gerouRota = false;
        if (showWarningToast) {
          this.toastr.warning('Houve algum problema ao Gerar a Rota ...');
        }
      }
      else if (status === google.maps.DirectionsStatus.OK) {
        gerouRota = true;
        if (result)
          this.resultRoute = result;
      }

    }).catch(err => this.convivaErrors.handleResultError(err));

    if (!gerouRota) {
      return;
    }
    return await this.computeTotalDistance(this.resultRoute);
  }


  private getLatLong(lat: number, lng: number): google.maps.LatLng {
    return new google.maps.LatLng({ lat, lng });
  }
  private async computeTotalDistance(result: google.maps.DirectionsResult): Promise<RotaMaps | undefined> {

    const myroute = result.routes[0];
    const rotaCompleta: RotaMaps = <RotaMaps>{}
    if (!myroute) {
      return;
    }

    rotaCompleta.totalKm = 0;
    rotaCompleta.totalSeg = 0;
    myroute.legs.forEach((element) => {
      if (element.distance && element.duration) {
        rotaCompleta.totalKm += element.distance.value;
        rotaCompleta.totalSeg += element.duration.value;
      }
    });

    const hours = Math.floor(rotaCompleta.totalSeg / 3600) < 10 ? (`00${Math.floor(rotaCompleta.totalSeg / 3600)}`).slice(-2) : Math.floor(rotaCompleta.totalSeg / 3600);
    const minutes = (`00${Math.floor((rotaCompleta.totalSeg % 3600) / 60)}`).slice(-2);
    rotaCompleta.totalDuration = `${hours}:${minutes}`;
    //Converte em KM
    // rotaCompleta.totalKm = parseInt((rotaCompleta.totalKm / 1000).toString());
    rotaCompleta.totalKmFormatado = `${rotaCompleta.totalKm} m`; 

    return rotaCompleta;
    // var response = await lastValueFrom(this.utilsService.calcularHoras(this.form.horarioSaida.value, this.totalDuration))
    //                     .catch((err) => {
    //                       return this.ConvivaErrors.handleResultError(err);
    //                     });

    // if(!response.isSucess){
    //   this.toastr.error(response.message);
    //   this.spinnerService.hide();
    //   return;
    // }

    // this.form.horarioChegada.setValue(response.data);
  }
}

